import '../../../app.css';
import '../../game.css';

const React = require('react');
const styles = require('../../game.style').default;
const timer = require('../../../../core/timer').default;
const ModalWindow = require('../../../../core/modal').default;
// ============================

export default class gamePauseComponent extends React.Component {
    getElapsedTime() {
        const { gameState: { baseTime, startedAt, stoppedAt } } = this.props;
        return timer.getElapsedTime(baseTime, startedAt, stoppedAt);
    }

    getSkillElapsedTime() {
        const { playerState: { baseTime, startedAt, stoppedAt } } = this.props;
        return timer.getElapsedTime(baseTime, startedAt, stoppedAt);
    }

    renderContents() {
        const { playerState: { playerName } } = this.props;
        return (
            <div style={styles.modalStyle}>
                <div className="dialog">
                    <div className="dialog-header-bg">
                        <div className="dialog-header">公開:AFK(1/20)</div>
                    </div>
                    <div className="dialog-contents">
                        <div className="modal-chat">
                            <div className="modal-messages">
                                <div className="modal-messages-content">{playerName}:あｆｋしてます</div>
                            </div>
                            <div className="modal-culmun" >
                                <div className="modal-messages-content">{playerName}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        )
    }

    render() {
        return <ModalWindow
            isModalOpen={this.props.isModalOpen}
            closeRequest={() => this.props.handleBackClick(this.getElapsedTime(), this.getSkillElapsedTime())}
            isCloseOutOfArea={true}
            contents={this.renderContents()}
        />
    }
}